interface LoadScriptOptions {
  url: string;
  async?: boolean;
  id?: string;
  retry?: number;
  onError?: (error: Error) => void;
}
const LoadScript = (options: LoadScriptOptions) => {
  return new Promise<void>((resolve, reject) => LoadScriptWithRetry(options, 1, resolve, reject));
};

const LoadScriptWithRetry = (
  options: LoadScriptOptions,
  retryAttempt: number,
  resolve: () => void,
  reject: (reason?: unknown) => void
) => {
  // Check if script is already loaded
  if (options.id && document.getElementById(options.id)) {
    return resolve();
  }

  const script = document.createElement("script");
  if (options.id) {
    script.setAttribute("id", options.id);
  }

  script.src = options.url;
  script.async = options.async || false;

  script.addEventListener("load", resolve);
  script.addEventListener("error", () => {
    document.body.removeChild(script);
    if (options.retry && options.retry >= (retryAttempt ?? 1)) {
      const backOff = Math.min(retryAttempt > 1 ? 2 ** retryAttempt * 1000 : 1000, 30 * 1000);

      setTimeout(() => {
        LoadScriptWithRetry(options, ++retryAttempt, resolve, reject);
      }, backOff);
    } else {
      reject(new Error(`Failed to load script: ${options.url}`));
    }
  });

  document.body.appendChild(script);
};

export { LoadScript };
export type { LoadScriptOptions };
